import DOMPurify from "dompurify";
import {useAppState} from "@/store";
import {parseMergeTags} from "@/helpers";

export default function StepTitles({title, secondaryTitle, tertiaryTitle}) {
    const {state} = useAppState()
    return (
        <>
            {title && (
                <div className="heading-h1 mb-[8px]">
                    {parseMergeTags(title, state)}
                </div>
            )}
            {secondaryTitle && (
                <div
                    className="text-big text-brand-grey mb-[8px] [&>:last-child]:mb-0"
                    dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(parseMergeTags(secondaryTitle, state))}}
                />
            )}
            {tertiaryTitle && (
                <div className={"text-base text-brand-orange italic"}>
                    {parseMergeTags(tertiaryTitle, state)}
                </div>
            )}
        </>
    )
}
